import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import type { StatsTerminalRes } from '@/views/dashboard/home/home.service'

export interface RequestParams {
  /** 开始时间戳（秒级） */
  start_time: string
  /** 结束时间戳（秒级） */
  end_time: string
}

export interface Overview {
  /** 统计时段内外发总次数 */
  total_send_count: number
  /** 统计时段内涉及外发文件总数 */
  total_file_count: number
  /** 统计时段内敏感文件数（按文件去重） */
  sensitive_file_count: number
  /** 统计时段内放行次数 */
  allowed_count: number
  /** 统计时段内阻断次数 */
  blocked_count: number
}

export interface ChannelDistribution {
  /** 渠道类型（1-网络协议 2-通信软件 3-网盘 4-传播设备 99-其他） */
  channel_type: string
  /** 该渠道放行次数 */
  allowed_count: number
  /** 该渠道阻断次数 */
  blocked_count: number
  /** 该渠道总外发次数（放行+阻断） */
  total_count: number
}

export interface ResponseData {
  /** 渠道分布数据 */
  channel_distribution?: ChannelDistribution[]
  overview?: Overview
}
export interface SystemDistribution {
  /** 系统类型：0-全部，1-windows,2-linux，3-windows server，4-mac 5-未知 */
  system_type: number
  /** 该系统类型的终端数量 */
  count: number
  /** 系统名称（前端展示用） */
  system_name: string
}
export interface DistributionResponseData {
  /** 风险类型列表 */
  risk_types: string[]
  /** 数量列表 */
  counts: number[]
}
export interface OsVersionList {
  /** 系统类型 1-windows, 2-linux, 3-windows server, 4-mac */
  system_type: number
  /** 系统类型名称 */
  system_name: string
  /** 终端数量 */
  count: number
}

export interface OsResponseData {
  /** 系统版本分布列表 */
  os_version_list: OsVersionList[]
}
export interface RiskTrendRequestParams {
  /** 开始时间（Unix时间戳，秒） */
  start_time: string
  /** 结束时间（Unix时间戳，秒） */
  end_time: string
  /** 时间粒度 */
  granularity: string
}

export interface RiskTrendResponseData {
  /** 基线风险终端数量列表 */
  baseline_risk_counts?: number[]
  /** 漏洞风险终端数量列表 */
  leak_risk_counts?: number[]
  /** 端口风险终端数量列表 */
  port_risk_counts?: number[]
  /** 勒索风险终端数量列表 */
  ransomware_risk_counts?: number[]
  /** 时间点列表（Unix时间戳，秒） */
  time_points?: string[]
  /** 病毒风险终端数量列表 */
  virus_risk_counts?: number[]
  /** 弱口令终端数量列表 */
  weak_password_affect_counts?: number[]
}
export interface HomepageAuthSoftStatusResponseDataList {
  /** 数值 */
  value: number
  /** 名称 */
  name?: string
}

export interface HomepageAuthSoftStatusResponseData {
  /** 正版授权软件数（个） */
  auth_soft_count?: number
  /** 终端安装数为top5的正版软件 */
  list?: HomepageAuthSoftStatusResponseDataList[]
  /** 正版软件安装终端台 */
  soft_terminal_count?: number
}
export interface AuthSoftUseStatResponseData {
  /** 已授权正版软件数（已创建授权的正版软件数量） */
  auth_soft_count?: number
  /** 未授权正版软件数（已发现且未授权的正版软件数量） */
  install_count?: number
  /** 最高频率使用软件（启动次数最多的正版软件） */
  max_times_soft?: string
  /** 闲置正版软件（近7天未使用过的软件数量） */
  total_count?: number
}
@Injectable()
export class SensitivefilesendHomepageStatService {
  constructor (private http: Http) {}

  getSensitivefilesendHomepageStat (data: RequestParams) {
    return this.http.post<ResponseData>('/sensitivefilesend/homepage_stat', data)
  }
  // 病毒类型分布
  getSafemonitorVirusScanDistribution () {
    return this.http.post<DistributionResponseData>('/safemonitor/virus-scan/distribution', {})
  }
  // 获取终端系统版本分布
  getTerminalOsDistribution () {
    return this.http.post<OsResponseData>('/terminal/os-distribution', {})
  }
  // 获取告警综合趋势
  getTerminalRiskTrend (data: RiskTrendRequestParams) {
    return this.http.post<RiskTrendResponseData>('/terminal/risk-trend', data)
  }
  // 正版软件使用分析统计报表
  getSoftmgrAuthSoftUseStat () {
    return this.http.post<AuthSoftUseStatResponseData>('/softmgr/auth-soft-use-stat', {})
  }
  // 软件资产数量及安装情况
  getHomepageAuthSoftStatus () {
    return this.http.post<HomepageAuthSoftStatusResponseData>('/homepage/auth-soft-status', {})
  }
  /** 首页/概览终端规模：已部署、未加入等 */
  getHomepageStatsTerminal () {
    return this.http.post<StatsTerminalRes>('/homepage/stats/terminal', {})
  }
}
